import { User } from 'users/types';

export const generateUserObject = (user: User): User => ({
  ...user,
  name: `${user.firstName} ${user.lastName}`,
});
